import { connect } from 'react-redux';
import get from 'lodash/get';
import MockCancelOrRefundFlowComponent from '../../../components/tools/mock/MockCancelOrRefundFlowComponent';
import { setSelectedTask } from '../../../actions/tools/OrdersSearchActions';
import { setMockPageState } from '../../../actions/index';
import { hydrateZendeskDropdowns } from '../../../actions/tools/ZendeskActions';
import { extractSelectedTicketFromState } from '../../../extractFromState';

function mapStateToProps(state) {
  const selectedTask = state.tools.ordersSearch.selectedTask;
  let dropdownItems;
  if (selectedTask === 'refundOrder') {
    dropdownItems =
      state.tools.zendesk.refundDropdown &&
      state.tools.zendesk.refundDropdown.map((item) => {
        return {
          id: item.value,
          value: item.name,
        };
      });
  } else {
    dropdownItems =
      state.tools.zendesk.cancelDropdown &&
      state.tools.zendesk.cancelDropdown.map((item) => {
        return {
          id: item.value,
          value: item.name,
        };
      });
  }

  return {
    selectedOrder: Object.assign({}, state.tools && state.tools.ordersSearch && state.tools.ordersSearch.selectedOrder),
    selectedConfig: { ...state.tools.ordersSearch.selectedConfig },
    selectedTask,
    pageState: get(state, 'ui.tools.mock.pageState', null),
    policy:
      selectedTask === 'cancelOrder'
        ? get(
            state,
            'tools.ordersSearch.selectedOrder.businessDetails.extraBusinessInfo.mockOrderInfo.mockCancelPolicy',
            null
          )
        : get(
            state,
            'tools.ordersSearch.selectedOrder.businessDetails.extraBusinessInfo.mockOrderInfo.mockRefundPolicy',
            null
          ),
    businessId: get(state, 'tools.ordersSearch.selectedOrder.businessDetails.id', null),
    zendeskDomain: get(state, 'tools.general.selectedToolDomains.zendesk', null),
    zendeskCancelDropdownId: get(
      state,
      'tools.general.selectedToolDomains.zendeskConfig.zendeskCancelDropdown.id',
      null
    ),
    zendeskRefundDropdownId: get(
      state,
      'tools.general.selectedToolDomains.zendeskConfig.zendeskRefundDropdown.id',
      null
    ),
    dropdownItems,
    selectedTicket: extractSelectedTicketFromState(state),
    expertId: state.user.id,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPageState(state) {
      return dispatch(setMockPageState(state));
    },
    hydrateZendeskDropdowns(domain, businessId, menuId, dropdownType) {
      return dispatch(hydrateZendeskDropdowns(domain, businessId, menuId, false, dropdownType));
    },
    setSelectedTask(selectedTask) {
      return dispatch(setSelectedTask(selectedTask));
    },
  };
};

const MockCancelOrRefundFlowContainer = connect(mapStateToProps, mapDispatchToProps)(MockCancelOrRefundFlowComponent);

export default MockCancelOrRefundFlowContainer;
